import React, { useMemo } from "react";
import { DownArrowIcon, GreenEllipse, RedEllipse } from "../../Icons";

const CardDropdown = ({ activeCard }) => {
  // ✅ Always call hooks — even if activeCard is null
  const cardImage = useMemo(() => {
    if (!activeCard) return null;

    if (activeCard.status === "Active") {
      if (activeCard.card_brand === "Visa")
        return "assets/logos/add-card-visa.png";
      if (activeCard.card_provider.toLowerCase() === "em")
        return "assets/logos/emoney-card.png";
      return "assets/logos/virtual-card.png";
    } else {
      if (activeCard.card_provider === "MM")
        return "assets/logos/virtual-card.png";
      if (activeCard.card_provider.toLowerCase() === "em")
        return "assets/logos/emoney-card.png";
      return "assets/logos/blockedOtherCardBg-1.png";
    }
  }, [activeCard]);

  if (!activeCard) return null;

  return (
    <div className="relative flex w-full justify-start items-center py-2 px-3 card-dropdown-wrapper rounded-xl cursor-pointer">
      <div className="flex">
        <img
          src={cardImage}
          alt="Card"
          className={`rounded-md ${
            activeCard.status !== "Active" ? "bg-zinc-400 opacity-60" : ""
          }`}
        />
        <div className="px-3">
          <p className="card-dropdown-cardholdername text-sm font-medium leading-5 tracking-[0.07px]">
            {activeCard.name}
          </p>
          <span className="flex pt-2 items-center justify-center space-x-1">
            {activeCard.status === "Active" ? <GreenEllipse /> : <RedEllipse />}
            <p className="card-dropdown-status">
              {activeCard.status} | · · {activeCard.card_number.slice(-4)}
            </p>
          </span>
        </div>
      </div>
      <div className="absolute inset-y-0 right-0 flex items-center pr-[18px] hover:cursor-pointer">
        <DownArrowIcon className="h-5 w-5" />
      </div>
    </div>
  );
};

export default CardDropdown;
